import { useState } from "react";
import { Link } from "wouter";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { apiRequest } from "@/lib/queryClient";

/**
 * `/esqueci-senha` — PÚBLICA. Sempre responde a mesma coisa: se houver e-mail, o
 * link chega por lá; quem só tem telefone pede ao administrador, que gera o link
 * na tela Usuários e manda por WhatsApp.
 */
export default function EsqueciSenhaPage() {
  const [identificador, setIdentificador] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setEnviando(true);
    try {
      await apiRequest("POST", "/api/auth/esqueci-senha", { identificador });
    } catch {
      // A resposta é sempre a mesma — inclusive num erro de rede não se diz nada diferente.
    } finally {
      setEnviando(false);
      setEnviado(true);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-8">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Esqueci minha senha</CardTitle>
          <CardDescription>Informe o e-mail ou telefone do seu acesso.</CardDescription>
        </CardHeader>
        <CardContent>
          {enviado ? (
            <div className="space-y-4" data-testid="esqueci-enviado">
              <p className="text-sm">
                Se este acesso tiver e-mail cadastrado, o link para definir uma nova senha chega em instantes.
                Se você entra pelo telefone, peça ao administrador da fazenda — ele gera o link e manda por WhatsApp.
              </p>
              <Button asChild variant="outline" className="w-full"><Link href="/login">Voltar ao login</Link></Button>
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="identificador">E-mail ou telefone</Label>
                <Input id="identificador" type="text" inputMode="email" autoComplete="username" value={identificador}
                  onChange={e => setIdentificador(e.target.value)} placeholder="seu@email.com ou (74) 99999-8888" data-testid="input-identificador" />
              </div>
              <Button type="submit" className="w-full" disabled={!identificador.trim() || enviando} data-testid="button-esqueci-senha">
                {enviando && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Enviar link
              </Button>
              <p className="text-center text-sm"><Link href="/login" className="underline underline-offset-2">Voltar ao login</Link></p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
